var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "600px",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "8" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            autofocus: "",
                            error: !!_vm.errors.label,
                            "error-messages": _vm.errors.label,
                            label: "Rótulo *",
                            counter: 100,
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 100 ||
                                "Máximo de 100 caracteres",
                            ],
                            placeholder: "Ex: Li e Concordo",
                            "persistent-placeholder": "",
                          },
                          model: {
                            value: _vm.model.label,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "label", $$v)
                            },
                            expression: "model.label",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            code: "",
                            "error-messages": _vm.errors.code,
                            label: "Código *",
                          },
                          model: {
                            value: _vm.model.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "code", $$v)
                            },
                            expression: "model.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            error: !!_vm.errors.description,
                            "error-messages": _vm.errors.description,
                            label: "Descrição",
                            counter: 255,
                            rows: "2",
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 255 ||
                                "Máximo de 255 caracteres",
                            ],
                            outlined: "",
                          },
                          model: {
                            value: _vm.model.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "description", $$v)
                            },
                            expression: "model.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            "error-messages": _vm.errors.color,
                            label: "Cor",
                            placeholder: "Ex: success, error, primary",
                            "persistent-placeholder": "",
                          },
                          model: {
                            value: _vm.model.color,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "color", $$v)
                            },
                            expression: "model.color",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            "error-messages": _vm.errors.icon,
                            label: "Ícone",
                            placeholder: "Ex: mdi-check, mdi-close",
                            "persistent-placeholder": "",
                          },
                          model: {
                            value: _vm.model.icon,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "icon", $$v)
                            },
                            expression: "model.icon",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-divider", { staticClass: "my-4" }),
                _c(
                  "v-row",
                  [
                    _c("v-col", { attrs: { cols: "12" } }, [
                      _c(
                        "span",
                        { staticClass: "subtitle-2 grey--text text--darken-1" },
                        [_vm._v("Configurações de Aceite")]
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Quando marcado, esta opção representa um aceite válido e o status será 'Assinado/Concluído'",
                            label: "Aceite Válido",
                            color: "success",
                          },
                          model: {
                            value: _vm.model.is_valid_acceptance,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "is_valid_acceptance", $$v)
                            },
                            expression: "model.is_valid_acceptance",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Quando marcado, o usuário será obrigado a preencher uma justificativa ao selecionar esta opção",
                            label: "Exigir Justificativa",
                            color: "warning",
                          },
                          model: {
                            value: _vm.model.require_justification,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "require_justification", $$v)
                            },
                            expression: "model.require_justification",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-switch", {
                          attrs: { color: "purple", inset: "", label: "Ativo" },
                          model: {
                            value: _vm.model.active,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "active", $$v)
                            },
                            expression: "model.active",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.model.label
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "pa-3", attrs: { outlined: "" } },
                              [
                                _c("v-card-subtitle", { staticClass: "pb-1" }, [
                                  _vm._v("Pré-visualização"),
                                ]),
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          color: _vm.model.color || "grey",
                                          outlined:
                                            !_vm.model.is_valid_acceptance,
                                          small: "",
                                        },
                                      },
                                      [
                                        _vm.model.icon
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: { left: "", small: "" },
                                              },
                                              [_vm._v(_vm._s(_vm.model.icon))]
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          " " + _vm._s(_vm.model.label) + " "
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.model.is_valid_acceptance
                                      ? _c(
                                          "v-chip",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              color: "success",
                                              "x-small": "",
                                              outlined: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [_vm._v("mdi-check-circle")]
                                            ),
                                            _vm._v(" Aceite Válido "),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.model.require_justification
                                      ? _c(
                                          "v-chip",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              color: "warning",
                                              "x-small": "",
                                              outlined: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [_vm._v("mdi-text-box")]
                                            ),
                                            _vm._v(" Requer Justificativa "),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }